import React from 'react';

export interface SecurityLogsFiltersPanelProps {
  filters: {
    type: string;
    severity: string;
    user_id: string;
    ip_address: string;
    start_date: string;
    end_date: string;
  };
  onChange: (key: string, value: string) => void;
}

const inputCls = 'w-full rounded-lg border border-[#223046] bg-[#0b1220] px-3 py-2 text-sm text-cockpit-text placeholder-cockpit-muted focus:outline-none focus:border-[#6366f1]/60';
const labelCls = 'block text-xs font-medium text-cockpit-text-2 mb-1.5';

const SecurityLogsFiltersPanel: React.FC<SecurityLogsFiltersPanelProps> = ({ filters, onChange }) => (
  <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-3 pt-3 border-t border-[#1a2537]">
    <div>
      <label className={labelCls}>Type d'événement</label>
      <select value={filters.type} onChange={(e) => onChange('type', e.target.value)} className={inputCls}>
        <option value="">Tous les types</option>
        <option value="auth_failure">Échec d'authentification</option>
        <option value="auth_success">Authentification réussie</option>
        <option value="rate_limit_exceeded">Limite dépassée</option>
        <option value="unauthorized_access">Accès non autorisé</option>
        <option value="suspicious_activity">Activité suspecte</option>
        <option value="invalid_token">Token invalide</option>
        <option value="permission_denied">Permission refusée</option>
      </select>
    </div>
    <div>
      <label className={labelCls}>Sévérité</label>
      <select value={filters.severity} onChange={(e) => onChange('severity', e.target.value)} className={inputCls}>
        <option value="">Tous les niveaux</option>
        <option value="critical">Critique</option>
        <option value="high">Élevée</option>
        <option value="medium">Moyenne</option>
        <option value="low">Faible</option>
      </select>
    </div>
    <div>
      <label className={labelCls}>ID Utilisateur</label>
      <input type="number" value={filters.user_id} onChange={(e) => onChange('user_id', e.target.value)} className={inputCls} placeholder="Ex: 123" />
    </div>
    <div>
      <label className={labelCls}>Adresse IP</label>
      <input type="text" value={filters.ip_address} onChange={(e) => onChange('ip_address', e.target.value)} className={`${inputCls} font-mono`} placeholder="192.168.1.1" />
    </div>
    <div>
      <label className={labelCls}>Date début</label>
      <input type="date" value={filters.start_date} onChange={(e) => onChange('start_date', e.target.value)} className={inputCls} />
    </div>
    <div>
      <label className={labelCls}>Date fin</label>
      <input type="date" value={filters.end_date} onChange={(e) => onChange('end_date', e.target.value)} className={inputCls} />
    </div>
  </div>
);

export default SecurityLogsFiltersPanel;
